import { LightbulbMultipleOffOutlineIcon } from './LightbulbMultipleOffOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 827B8418-9667-4429-A4D3-7C0553D1946E
 * name lightbulb-multiple-off-outline
 * version: 4.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lightbulb-multiple-off-outline.svg
 * tags
 * - Home Automation 
 */
export const LightbulbsOffOutlineIcon = LightbulbMultipleOffOutlineIcon;
export default LightbulbsOffOutlineIcon